import {
  faBarsSort as CollapsedMenuIcon,
  faBars as ExpandedMenuIcon
  // faBell as NotificationIcon,
  // faServer as SystemStatusIcon
} from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Badge from '@mui/material/Badge';
// import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { useAtom } from 'jotai';
import { useMemo } from 'react';

import CheckPermissions from '@/components/CheckPermissions';
import CreateTicketButton from '@/components/CreateTicketButton';
import LogScaleButton from '@/components/LogScaleButton';
import OrganizationDropdown from '@/components/OrganizationDropdown';
import UserAccountMenu from '@/components/UserAccountMenu';
import { PERMISSIONS } from '@/constants/auth.constants';
import {
  orgNotificationSettingsAtom,
  useValidateOrgNotificationSettings
} from '@/features/NotificationSettings/NotificationSettings.store';
import TicketCreateDialog from '@/features/TicketCreateDialog';
import { ticketSearchParamsAtom } from '@/pages/Dashboard/Dashboard.store';
import {
  organizationsAtom,
  selectedOrganizationAtom
} from '@/pages/Organizations';
import { ticketDialogIsOpenAtom } from '@/pages/Ticket';
import {
  openTicketsCountAtom,
  useFetchGroupByOptions
} from '@/pages/Tickets/Tickets.store';
import { isLayoutMobileAtom } from '@/store/layout';
import { isSidebarExpandedAtom, isSidebarOpenAtom } from '@/store/sidebar';

import { useTopbar } from './Topbar.hooks';
import useStyles from './Topbar.styles';

export const Topbar = () => {
  const [isLayoutMobile] = useAtom(isLayoutMobileAtom);
  const [isSidebarExpanded, setIsSidebarExpanded] = useAtom(
    isSidebarExpandedAtom
  );
  const [isSidebarOpen, setIsSidebarOpen] = useAtom(isSidebarOpenAtom);
  const [organizations] = useAtom(organizationsAtom);
  const [orgNotificationSettings] = useAtom(orgNotificationSettingsAtom);
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const [ticketDialogIsOpen] = useAtom(ticketDialogIsOpenAtom);
  const [ticketSearchParams] = useAtom(ticketSearchParamsAtom);
  const [, setOpenTicketsCount] = useAtom(openTicketsCountAtom);
  const { classes } = useStyles();
  const { NotificationAlert, TicketAlert } = useTopbar();

  useFetchGroupByOptions(
    ['ticket_status__name'],
    ticketSearchParams,
    (setValue) => {
      const openCount =
        setValue?.ticket_status__name?.find((option) => option.label === 'Open')
          ?.count || 0;
      setOpenTicketsCount(openCount);
    }
  );
  //-----------------------------------------------------------------
  const handleSidebar = () => {
    if (isLayoutMobile) {
      setIsSidebarOpen(!isSidebarOpen);
      return;
    }
    setIsSidebarExpanded(!isSidebarExpanded);
  };

  //-----------------------------------------------------------------
  useValidateOrgNotificationSettings();

  const missingOrgNotificationSettings = useMemo(() => {
    return Object.values(orgNotificationSettings).some(
      (value) => value === false
    );
  }, [orgNotificationSettings]);

  return (
    <>
      <div className={classes.topbar}>
        <Stack direction="row" sx={{ alignItems: 'center' }} spacing={2}>
          <IconButton
            sx={{ ml: -0.5 }}
            aria-label="toggle sidebar"
            onClick={handleSidebar}
          >
            {isSidebarExpanded && !isLayoutMobile && (
              <FontAwesomeIcon icon={CollapsedMenuIcon} />
            )}
            {(!isSidebarExpanded || isLayoutMobile) && (
              <FontAwesomeIcon icon={ExpandedMenuIcon} />
            )}
          </IconButton>
          {!isLayoutMobile && organizations.length > 1 && (
            <OrganizationDropdown />
          )}
        </Stack>
        {TicketAlert}
        {missingOrgNotificationSettings &&
          selectedOrganization.id !== 0 &&
          NotificationAlert}
        <div>
          <Stack direction="row" spacing={2}>
            <CheckPermissions permissions={PERMISSIONS.TICKETS_CREATE}>
              <CreateTicketButton />
            </CheckPermissions>
            {!isLayoutMobile && (
              <CheckPermissions permissions={PERMISSIONS.LOGS_READ}>
                <LogScaleButton />
              </CheckPermissions>
            )}
            {/* post-launch feature */}
            {/* <Badge
              badgeContent={1}
              color="warning"
              className={classes.topbarBadge}
            >
              <Button
                variant="twoTone"
                aria-label="notifications"
                onClick={(e) => toggleDrawer(e, 'notifications')}
                onKeyDown={(e) => toggleDrawer(e, 'notifications')}
                className={classes.topbarButton}
              >
                <FontAwesomeIcon icon={NotificationIcon} size="lg" />
              </Button>
            </Badge> */}
            {/* post-launch feature */}
            {/* <Badge
              badgeContent="!"
              color="error"
              className={classes.topbarBadge}
            >
              <Button
                aria-label="system status"
                variant="twoTone"
                onClick={(e) => toggleDrawer(e, 'system status')}
                onKeyDown={(e) => toggleDrawer(e, 'system status')}
                className={classes.topbarButton}
              >
                <FontAwesomeIcon icon={SystemStatusIcon} size="lg" />
              </Button>
            </Badge> */}
            <UserAccountMenu />
          </Stack>
        </div>
      </div>
      {/* <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={toggleDrawer}
        className={classes.topbarDrawer}
      >
        {drawerContent === 'notifications' ? (
          <h2>Notifications</h2>
        ) : (
          <h2>System Status</h2>
        )}
      </Drawer> */}
      {ticketDialogIsOpen && <TicketCreateDialog />}
    </>
  );
};

export default Topbar;
